import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { cn } from '@core/utils';
import type { PeriodOption } from '../constants';
import { ORDER_STATUS_OPTIONS, PERIOD_OPTIONS } from '../constants';
import type { OrderStatusValue } from '../types';
interface FilterSectionProps {
  orderStatus?: OrderStatusValue;
  period?: PeriodOption;
  onStatusChange?: (value: OrderStatusValue) => void;
  onPeriodChange?: (option: PeriodOption) => void;
}
export const FilterSection = t0 => {
  const $ = _c(12);
  const {
    orderStatus,
    period,
    onStatusChange,
    onPeriodChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex items-center justify-end gap-20 pb-16", "mobile-tablet:px-20");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = orderStatus || undefined;
  let t3;
  if ($[1] !== onStatusChange || $[2] !== t2) {
    t3 = <DropdownMenu options={ORDER_STATUS_OPTIONS} type="text" placeholder={"\uC0C1\uD0DC \uC804\uCCB4"} value={t2} onChange={onStatusChange} className="cursor-pointer" />;
    $[1] = onStatusChange;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = period?.value;
  let t5;
  if ($[4] !== onPeriodChange) {
    t5 = value => {
      const option = PERIOD_OPTIONS.find(periodOption => periodOption.value === value);
      if (option) {
        onPeriodChange?.(option);
      }
    };
    $[4] = onPeriodChange;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <DropdownMenu options={PERIOD_OPTIONS} type="text" placeholder={"\uC804\uCCB4"} value={t4} className="cursor-pointer" onChange={t5} />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <section className={t1}>{t3}{t6}</section>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};